export default __webpack_public_path__ + "static/media/AstronomyMercury_00.97a78bb3.png";